
import { lazy } from 'react';
import InstructorUploadPage from '../pages/instructor-upload/page';
import CourseCurriculumPage from '../pages/course-curriculum/page';
import PrivateRoute from '../Routes/PrivateRoute';

const HomePage = lazy(() => import('../pages/home/page'));
const CoursesPage = lazy(() => import('../pages/courses/page'));
const CourseDetailPage = lazy(() => import('../pages/course-detail/page'));
const MyLearningPage = lazy(() => import('../pages/my-learning/page'));
const CartPage = lazy(() => import('../pages/cart/page'));
const CheckoutPage = lazy(() => import('../pages/checkout/page'));
const InstructorDashboardPage = lazy(() => import('../pages/instructor-dashboard/page'));
const CreateCoursePage = lazy(() => import('../pages/create-course/page'));
const CourseLearningPage = lazy(() => import('../pages/course-learning/page'));
const LoginPage = lazy(() => import('../pages/auth/login/page'));
const RegisterPage = lazy(() => import('../pages/auth/register/page'));
const OnboardingPage = lazy(() => import('../pages/auth/onboarding/page'));
const ForgotPasswordPage = lazy(() => import('../pages/auth/forgot-password/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/courses',
    element: <CoursesPage />,
  },
  {
    path: '/course/:id',
    element: <CourseDetailPage />,
  },
  {
    path: '/course/:id/learn',
    element: <CourseLearningPage />,
  },
  {
    path: '/my-learning',
    element: (
      <PrivateRoute>
        <>
          <MyLearningPage />
        </>
        </PrivateRoute>
    ),
  },
  {
    path: '/cart',
    element: <CartPage />,
  },
  {
    path: '/checkout',
    element: <CheckoutPage />,
  },
  {
    path: '/instructor',
    element: <InstructorDashboardPage />,
  },
  {
    path: '/instructor/create-course',
    element: <CreateCoursePage />,
  },
  {
    path: '/instructor/upload',
    element: <InstructorUploadPage />,
  },
  {
    path: '/instructor/course/:id/curriculum',
    element: <CourseCurriculumPage />,
  },
  {
    path: '/auth/login',
    element: <LoginPage />,
  },
  {
    path: '/auth/register',
    element: <RegisterPage />,
  },
  {
    path: '/auth/onboarding',
    element: <OnboardingPage />,
  },
  {
    path: '/auth/forgot-password',
    element: <ForgotPasswordPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
